'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = exports.product = exports.date = exports.history = exports.location = exports.match = undefined;
var _propTypes = require('prop-types');

// React Router
var match = exports.match = (0, _propTypes.shape)({
  params: _propTypes.object,
  isExact: _propTypes.bool,
  path: _propTypes.string,
  url: _propTypes.string
});
var location = exports.location = (0, _propTypes.shape)({
  key: _propTypes.string,
  pathname: _propTypes.string,
  search: _propTypes.string,
  hash: _propTypes.string,
  state: _propTypes.object
});
var history = exports.history = (0, _propTypes.shape)({
  length: _propTypes.number,
  location: _propTypes.object,
  action: _propTypes.string
});
var date = exports.date = (0, _propTypes.shape)({
  year: _propTypes.number,
  month: _propTypes.number,
  day: _propTypes.number,
  dayOfWeek: _propTypes.string,
  hour: _propTypes.number,
  minute: _propTypes.number,
  second: _propTypes.number
});
var product = exports.product = (0, _propTypes.oneOf)(['ndi', 'fdi', 'ldi', 'sdi', 'cfy', 'all', 'broker', 'admin']);
var options = exports.options = (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
  value: _propTypes.string,
  text: _propTypes.string
})]));